window.addEventListener('DOMContentLoaded', () => {
  addParentElement()
  keepBrandAgentClearOfStickyBar()

  const accordionContainer1 = document.querySelector('[id$="__collection_list_Pr36qH"]');
  const accordionContainer2 = document.querySelector('[id$="__collection_list_bK4CY9"]');
  accordion(accordionContainer1, 'すべてのブランドを見る');
  accordion(accordionContainer2, 'すべてのキーワードを見る');
})

const keepBrandAgentClearOfStickyBar = () => {
  const styleId = 'sakura-brand-agent-position';

  const addPositionStyle = () => {
    const shadowRoot = document.querySelector('#ads-agent-host')?.shadowRoot;
    if (!shadowRoot) return false;
    if (shadowRoot.querySelector(`#${styleId}`)) return true;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      [data-testid="entrypoint"] {
        bottom: var(--sakura-brand-agent-bottom, 1.5rem) !important;
        margin-bottom: 0 !important;
      }
    `;
    shadowRoot.appendChild(style);
    return true;
  };

  if (addPositionStyle()) return;

  const observer = new MutationObserver(() => {
    if (addPositionStyle()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
}

window.addEventListener('load', () => {
  localizePasscodeForm();
  addAfterPasswordInfo();
});

const localizePasscodeForm = () => {
  const wrapper = document.querySelector('.lockAccess__wrapper');
  const input = wrapper?.querySelector('#passcode');
  const submitLabel = wrapper?.querySelector('#passcodebtn span');
  if (!wrapper || !input || !submitLabel) return;

  const instruction = input.closest('.Lock__passcodeInputWrapper')?.previousElementSibling;
  if (instruction) {
    instruction.textContent = 'パスワードを入力して商品をご購入ください';
  }

  input.placeholder = 'パスワードを入力';
  input.setAttribute('aria-label', 'パスワード');
  submitLabel.textContent = '確認する';

  const emptyError = wrapper.querySelector('.Lock__Error-empty');
  const wrongError = wrapper.querySelector('.Lock__Error-wrong');
  if (emptyError) emptyError.textContent = 'パスワードを入力してください。';
  if (wrongError) wrongError.textContent = 'パスワードが正しくありません。';
}

const addParentElement = () => {
  const child1 = document.querySelector('[id$="__collection_list_rKRpQ3"]');
  const child2 = document.querySelector('[id$="__collection_list_jRrH6T"]');
  const parent = document.createElement('div');

  if (child1 && child2) {
    parent.classList.add('p-topWrapper');
    parent.classList.add('page-width');
    child1.parentNode.insertBefore(parent, child1);
    parent.appendChild(child1);
    parent.appendChild(child2);
  }
}

const accordion = (element, text) => {
  if (!element) return;
  const content = element.querySelector('.section__content');
  if (!content) return;
  const child = content.children[0]
  if (content.clientHeight >= child.clientHeight) return;


  // ボタンのラッパー要素を作成
  const buttonWrapper = document.createElement('div');
  buttonWrapper.classList.add('accordion-button-wrapper');
  // ボタンを作成
  const button = document.createElement('button');
  button.classList.add('accordion-button');
  button.textContent = text;
  buttonWrapper.appendChild(button);
  // ボタンをコンテンツの後に挿入
  content.insertAdjacentElement('afterend', buttonWrapper);

  // ボタンのクリックイベントを設定
  button.addEventListener('click', () => {
    const isActive = button.classList.contains('active-accordion');
    // クリックされたボタンがアクティブでない場合のみ開く
    if (!isActive) {
      button.classList.add('active-accordion');
      content.classList.add('active-accordion');
      content.style.height = content.scrollHeight + 'px'; // コンテンツの高さを設定
      button.textContent = '閉じる';
    } else {
      button.classList.remove('active-accordion');
      content.classList.remove('active-accordion');
      content.style.height = '';
      button.textContent = text;
    }
  });
}

const addAfterPasswordInfo = () => {
  const wrapper = document.querySelector('.lockAccess__wrapper');
  console.log('lockAccess__wrapper:', wrapper);
  if (wrapper) {
    console.log('Adding password info after lockAccess__wrapper');
    const info = document.createElement('div');
    info.classList.add('lockAccess__info');
    info.innerHTML = `
      <div class="p-productInfo">
        <h2>パスワードをお持ちでない方はこちら</h2>
        <div class="p-productInfo__content">
          <ul>
            <li><a href="https://www.instagram.com/anjosakuraclinic/" target="_blank">Instagramでお問い合わせ</a></li>
            <li><a href="https://line.me/R/ti/p/@381ufmhm" target="_blank">公式LINEからのお問い合わせ</a></li>
          </ul>
          <p>※お問い合わせ時は、こちらの内容をご連絡ください。<br>お名前 / 受診歴の有無 / 商品 / 名個数</p>
        </div>
      </div>
    `;
    wrapper.appendChild(info);
  }
}
